<template>
    <v-app>
        <project-type-setup :dialog="projectTypeDialog" :data="data" @update:dialog="projectTypeDialog = $event" />  
        <contact-setup :dialog="contactDialog" :data="data" @update:dialog="contactDialog = $event" />  
        <project-theme-setup :dialog="projectThemeDialog" :data="data" @update:dialog="projectThemeDialog = $event" />  
        <sales-order-setup :dialog="dialog" :data="data" @update:dialog="dialog = $event" @save-author="saveAuthorHandler" />

        <v-container fluid>
            <template v-if="$insertAccess($route.path)">
                <v-form @submit.prevent="submit">
                    <v-row>
                        <v-col cols="12">
                            <v-expansion-panels v-model="panel">
                                <v-expansion-panel>
                                   <v-expansion-panel-title
                                        color="blue-grey-lighten-5"
                                        class="panel-header font-weight-medium text-primary"
                                    >
                                        <v-icon start color="primary" class="mr-2">mdi-information-outline</v-icon>
                                        <span>{{ isEntryMode ? "Add Project Info" : "Update Project Info" }}</span>
                                    </v-expansion-panel-title>
                                    
                                    <v-expansion-panel-text>
                                        <v-row class="py-2 no-gutters justify-space-around">
                                            <v-col lg="4" md="4" cols="12">
                                                <v-date-input
                                                    prepend-icon=""
                                                    prepend-inner-icon="mdi-calendar"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="project_date.value.value"
                                                    autocomplete="off"
                                                    clearable
                                                    :error-messages="project_date.errorMessage.value"
                                                    >
                                                        <template #label>
                                                            Project Date
                                                            <span class="text-red-accent-4">*</span>
                                                        </template>
                                                </v-date-input>
                                                <v-text-field
                                                    v-model="project_title.value.value"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    clearable
                                                    :error-messages="project_title.errorMessage.value"
                                                    >
                                                    <template #label>
                                                        Project Title / Name
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-text-field>

                                                <v-text-field
                                                    v-model="approval_ref.value.value"
                                                    label="Contract Package Name/No"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    :error-messages="approval_ref.errorMessage.value"
                                                    clearable
                                                ></v-text-field>

                                                <v-text-field
                                                    v-model="customer_name.value.value"
                                                    label="Client"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    :error-messages="customer_name.errorMessage.value"
                                                    autocomplete="off"                                               
                                                ></v-text-field>
                                            </v-col>

                                            <v-col lg="4" md="4" cols="12">
                                                <v-autocomplete
                                                    v-model="installation_type.value.value"
                                                    :items="installationTypes"
                                                    :item-title="(item) => item ? item.label : ''"
                                                    item-value="value"
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    clearable
                                                    autocomplete="off"
                                                    :error-messages="installation_type.errorMessage.value"
                                                >
                                                    <template #label>
                                                        Project Nature
                                                    </template>
                                                </v-autocomplete>

                                                <v-text-field
                                                    v-model="address.value.value"
                                                    label="Project Location"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    :error-messages="address.errorMessage.value"
                                                    clearable
                                                ></v-text-field>


                                                <v-autocomplete
                                                    v-model="registration_type.value.value"
                                                    :items="registrationTypes"
                                                    :item-title="(item) => item ? item.label : ''"
                                                    item-value="value"
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    clearable
                                                    autocomplete="off"
                                                    :error-messages="registration_type.errorMessage.value"
                                                >
                                                    <template #label>
                                                        Project Status
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-autocomplete>
                                               
                                                <v-text-field
                                                v-model="amount.value.value"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                :error-messages="amount.errorMessage.value"
                                                @update:model-value="onRetentionChange"
                                                clearable
                                                >
                                                    <template #label>
                                                        Project Contact Value
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-text-field>
                                            </v-col>
                                            
                                            <v-col lg="4" md="4" cols="12">
                                                
                                                 <v-text-field
                                                    v-model="expense_limit.value.value"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    type="number"
                                                    :error-messages="expense_limit.errorMessage.value"
                                                    clearable
                                                    >
                                                        <template #label>
                                                            Project Expense Limit
                                                            <span class="text-red-accent-4">*</span>
                                                        </template>
                                                </v-text-field>
                                               
                                                <v-date-input
                                                v-model="start_date.value.value"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                autocomplete="off"
                                                :error-messages="start_date.errorMessage.value"
                                                clearable
                                                >
                                                    <template #label>
                                                        Project Start Date
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-date-input>

                                                <v-date-input
                                                v-model="end_date.value.value"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                autocomplete="off"
                                                :error-messages="end_date.errorMessage.value"
                                                clearable
                                                >
                                                    <template #label>
                                                        Project End Date
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-date-input>    

                                                <v-textarea
                                                    v-model="description.value.value"
                                                    label="Project Description"
                                                    rows="3"
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    autocomplete="off"
                                                    :error-messages="description.errorMessage.value"
                                                    clearable
                                                ></v-textarea>

                                                <input v-model="project_id.value.value" type="hidden">
                                            </v-col>
                                        </v-row>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>

                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn
                                class="bg-grey-darken-1 me-2"
                                variant="flat"
                                @click="submitForm(0)"
                                >DRAFT</v-btn
                            >

                             <v-btn
                                class="bg-primary"
                                variant="flat"
                                @click="submitForm(1)"
                                >{{ isEntryMode ? "Save" : "Update" }}</v-btn
                            >
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </template>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { getCurrentInstance, ref, reactive } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";
import formattedDate from "@/plugins/dateFormatter";
import SalesOrderSetup from "@/components/module/project/projectManagement/salesOrderSetup.vue";
import ContactSetup from '@/components/module/project/settingManagement/contactSetup.vue';
import ProjectThemeSetup from '@/components/module/project/settingManagement/projectThemeSetup.vue';
import ProjectTypeSetup from '@/components/module/project/settingManagement/projectTypeSetup.vue';

export default {
    components: {
        SalesOrderSetup,
        ProjectTypeSetup,
        ProjectThemeSetup,
        ContactSetup,
    },

    data: () => ({
        itemsPerPage: 10,
        panel: [0],
        contactPersonInfo: [0],
        search: "",
        isEntryMode: true,
        dialog: false,
        projectTypeDialog: false,
        projectThemeDialog: false,
        contactDialog: false,
        data: {},
        installationTypes: [{ value: 'construction', label: 'Construction' }, { value: 'supply', label: 'Supply' }, { value: 'supply_installation', label: 'Supply & Installation' }, { value: 'supply_construction', label: 'Supply & Construction' }],
        registrationTypes: [{value: 'ongoing', label: 'Ongoing'}, {value: 'completed', label: 'Completed'}, { value: 'upcoming', label: 'Upcoming'}, { value: 'closed', label: 'Closed' }],
        authors: [],
        headers: [
            { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
            { title: "Agreed Amount", key: "agreed_amount", align: "left", sortable: false },
            { title: "Payment Date", key: "date_of_enroll", align: "left", sortable: false },
            { title: "Payment Type", key: "payment_type", align: "left" ,sortable: false },
            { title: "Next Payment Date", key: "next_payment_date", align: "left", sortable: false },
            { title: "Previous Paid", key: "paid_amount", align: "left", sortable: false },
            { title: "Receive", key: "receive_amount", align: "left", sortable: false },
            { title: "Due", key: "due_amount", align: "left" ,sortable: false },
            { title: "Actions", align: "center", key: "actions", sortable: false }
        ],
        projectTypes: [
            { id: 1, name: "Special Project" },
            { id: 2, name: "Regular Project" },
            { id: 3, name: "Collaborative Project" },
            { id: 4, name: "Book Chapter" },
            { id: 5, name: "Researcher Project" },
        ],
    }),

    watch: {
        authors: {
            handler(newVal, oldVal) {
            },
            deep: true, 
        },
        '$route.query': {
            handler() {
                this.loadData()
            },
            deep: true,
            immediate: false
        },
        // getProjectTypeList(newList) {
        //     if (
        //         this.$route.query.id &&
        //         this.$store.getters.getEditingProject &&
        //         newList.length > 0
        //     ) {
        //         const project = this.$store.getters.getEditingProject;
        //         this.project_type_id.value.value = project.project_type_id;
        //     }
        // },
        // getContactList(newList) {
        //     if (
        //         this.$route.query.id &&
        //         this.$store.getters.getEditingProject &&
        //         newList.length > 0
        //     ) {
        //         const project = this.$store.getters.getEditingProject;
        //         this.contact_id.value.value = project.contact_id;
        //     }
        // },
        // getProjectThemeList(newList) {
        //     if (
        //         this.$route.query.id &&
        //         this.$store.getters.getEditingProject &&
        //         newList.length > 0
        //     ) {
        //         const project = this.$store.getters.getEditingProject;
        //         this.project_theme_id.value.value = project.project_theme_id;
        //     }
        // },
    },

    created() {
        if (this.$store.getters.getContactList.length === 0) {
            this.$store.dispatch("getContactList");
        }
        if (this.$store.getters.getProjectTypeList.length === 0) {
            this.$store.dispatch("getProjectTypeList");
        }
        if (this.$store.getters.getProjectThemeList.length === 0) {
            this.$store.dispatch("getProjectThemeList");
        }
        if (this.$store.getters.getCustomerMapList.length === 0) {
            this.$store.dispatch("getCustomerMapList");
        }
    },

    computed: {
        getContactList() {
            return this.$store.getters.getContactList;
        },
        getProjectTypeList() {
            return this.$store.getters.getProjectTypeList;
        },
        getProjectThemeList() {
            return this.$store.getters.getProjectThemeList;
        },
        getCustomerMapList() {
            return this.$store.getters.getCustomerMapList;
        },
        getPaidAmount() {
            return this.authors.reduce((sum, author) => +sum + +author.receive_amount, 0);
        }
    },

    methods: {
        openAddAuthor() {
            this.data = {
                amount: this.amount.value.value,
                paid: this.getPaidAmount
            };
            this.dialog = true;
        },
        openAddProjectTheme() {
            this.data = {
                id: '',
                name: '',
                code: '',
                remarks: '',
                status: 1,
            };
            this.projectThemeDialog = true;
        },
        openAddProjectType() {
            this.data = {
                id: '',
                name: '',
                code: '',
                remarks: '',
                status: 1,
            };
            this.projectTypeDialog = true;
        },
        openAddContact() {
            this.data = {
                id: '',
                name: '',
                code: '',
                remarks: '',
                status: 1,
            };
            this.contactDialog = true;
        },

        closeDialog() {
            this.dialog = false;
            this.projectThemeDialog = false;
            this.projectTypeDialog = false;
            this.contactDialog = false;
            this.data = {};
        },

        // async onCustomerChange(id) {
        //     if (!id) {
        //         this.customer_address.value.value = "";
        //         return;
        //     }
        //     const list = this.$store.getters.getCustomerMapList || [];
        //     let entry = list.find((it) => {
        //         return it.customer_id == id || (it.customer && (it.customer.id == id || it.customer.customer_id == id));
        //     });

        //     let customer = entry ? entry.customer : null;

        //     if (!customer) {
        //         try {
        //             customer = await this.$store.dispatch("getCustomerById", id);
        //         } catch (err) {
        //             customer = null;
        //         }
        //     }

        //      if (customer) {
        //         this.customer_address.value.value = customer.company_address;
        //      } else {
        //         this.customer_address.value.value = "";
        //      }

        // },

        onRetentionChange() {
            // this.retention.value.value = 0;
            // this.retention_per.value.value = 0;
            if(this.retention_per.value.value) {
                const val = this.retention_per.value.value.toString().trim();
                if (val.endsWith("%")) {
                    const percentage = parseFloat(val.replace("%", ""));
                    this.retention.value.value = (this.amount.value.value * percentage) / 100 || 0;
                } else {
                    this.retention.value.value =this.retention_per.value.value;
                }
            }
        },

        saveAuthorHandler(author) {
            if(Number.isInteger(author.array_index)) {
                // const index = this.authors.findIndex(a => a.array_index == author.array_index);
                this.authors[author.array_index] = author;
                // console.log(author);
                // if (index !== -1) {
                //     this.authors.splice(index, 1, author);
                // } else {
                //     this.authors.push(author);
                // }
            } else {
                this.authors.push(author);
            }
            // I want agreed_amount to be sum of all agreed_amount in this.authors
            // this.amount.value.value = this.authors.reduce((sum, author) => +sum + +author.agreed_amount, 0);
        },
        deleteItem(item) {
            if (confirm('Are you sure you want to delete this sales order?')) {
                const index = this.authors.findIndex(order => order.id === item.id);
                if (index !== -1) {
                    this.authors.splice(index, 1);
                    toast.success('Sales order removed successfully');
                    // this.amount.value.value = this.authors.reduce((sum, author) => +sum + +author.agreed_amount, 0);
                }
            }
        },

        editItem(item, index) {
            this.data = { ...item, arrIndex: index, amount: this.amount.value.value, };
            this.dialog = true;
        },

        exportToExcel() {
            var data = [['#SL', 'Project Code', 'Project Title', 'Point of Contact', 'Author Name', 'Author Type', 'Phone', 'Contacted By', 'Agreed Amount', 'Paid', 'Due.', 'Bio']];
            var serialNumber = 1;
            this.authors.forEach(item => {
                data.push([serialNumber++, item.project.code, item.project.project_title, item.project.contacted_by.name, item.name, item.author_type_name, item.phone, item.contacted_by_name, item.agreed_amount, item.paid_amount, item.due_amount, item.bio]);
            });
            this.$exportTableToExcel(data, 'author_list_' + this.$fileDate());
        },

        loadData() {
            // const proxy = this.$.setupState;
            const queryId = this.$route.query.id;
            if (this.$store.getters.getEditingProject && queryId) {
                this.$store.commit('SET_LOADING', { color: 'primary' });
                this.isEntryMode = false;
                const project = this.$store.getters.getEditingProject;
                this.project_id.value.value = project.id;
                this.project_title.value.value = project.project_title;
                this.registration_type.value.value = project.registration_type,
                this.installation_type.value.value = project.installation_type,
                this.contact_id.value.value = project.contact_id;
                this.project_type_id.value.value = project.project_type_id;
                this.customer_name.value.value = project.customer_name;
                this.start_date.value.value = project.start_date;
                this.end_date.value.value = project.end_date;
                this.work_order_no.value.value = project.work_order_no;
                this.work_order_date.value.value = project.work_order_date;
                this.description.value.value = project.description;
                this.address.value.value = project.address;
                this.amount.value.value = project.amount;
                this.retention.value.value = project.retention;
                this.retention_per.value.value = project.retention_per;
                this.project_deliverable_date.value.value = project.project_deliverable_date;
                this.retention_return_date.value.value = project.retention_return_date;
                this.expense_limit.value.value = project.expense_limit;
                // this.whatsapp_link.value.value = project.whatsapp_link;
                // this.google_link.value.value = project.google_link;
                this.approval_ref.value.value = project.approval_ref;
                this.project_date.value.value = project.project_date;
                this.status.value.value = project.status == 1 ? '1' : '0';
                this.authors = [...project.project_payments];
                this.$store.commit('UNSET_LOADING');
            } else {
                this.$store.commit('setEditingProject', null)
                this.project_id.value.value = '';
                this.isEntryMode = true;
                this.resetForm();
                this.authors = []
                this.amount.value.value = 0;
            }
        }
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                project_date: yup.string().required().label("Project Date"),
                // project_type_id: yup.number().required().label("Project Type"),
                // contact_id: yup.number().nullable().label("Contact"),
                customer_name: yup.string().nullable().label("Customer"),
                project_title: yup.string().min(3).required().label("Project Title"),
                expense_limit: yup.number().nullable().max(yup.ref('amount'), 'Expense limit cannot be greater than amount').label("Expense Limit"),
                amount: yup.number().nullable().label("Amount"),
                // retention: yup.number().nullable().max(yup.ref('amount'), 'Retention cannot be greater than amount').label("Retention"),
                // retention_per: yup.string().nullable().label("Retention"),
                start_date: yup.string().nullable().label("Start Date"),
                end_date: yup.string().nullable().label("End Date"),
                installation_type: yup.string().nullable().label("Installation Type"),
                work_order_no: yup.string().max(50).nullable().label("Work Order No"),
                work_order_date: yup.string().nullable().label("Work Order Date"),
                registration_type: yup.string().nullable().label("Registration"),
                description: yup.string().nullable(),
                address: yup.string().nullable(),
                approval_ref: yup.string().nullable(),
                project_deliverable_date: yup.string().nullable(),
                retention_return_date: yup.string().nullable()
            }),
        });

        const project_title = useField("project_title");
        const contact_id = useField("contact_id");
        const project_type_id = useField("project_type_id");
        const customer_name = useField("customer_name");
        const customer_address = useField("customer_address");
        const start_date = useField("start_date");
        const installation_type = useField("installation_type");
        const end_date = useField("end_date");
        const work_order_no = useField("work_order_no");
        const work_order_date = useField("work_order_date");
        const description = useField("description");
        const address = useField("address");
        const amount = useField("amount");
        const retention = useField("retention");
        const retention_per = useField("retention_per");
        const expense_limit = useField("expense_limit");
        const registration_type = useField("registration_type");
        const project_deliverable_date = useField("project_deliverable_date");
        const retention_return_date = useField("retention_return_date");
        const whatsapp_link = useField("whatsapp_link");
        const google_link = useField("google_link");
        const approval_ref = useField("approval_ref");
        const project_date = useField("project_date");
        const authors = ref([]);

        const status = useField("status");
        const project_id = useField('project_id');

        const errorMessages = ref("");
        const loading = ref("");
        const isEntryMode = ref(true);
        
        const store = useStore();
        const router = useRouter();

        
        const submitForm = (btnStatus) => {
            status.value.value = btnStatus;
            submit();
        };


        const submit = handleSubmit((values) => {
            values.project_date = formattedDate(project_date.value.value);
            values.start_date = formattedDate(start_date.value.value);
            values.end_date = formattedDate(end_date.value.value);
            values.work_order_date = formattedDate(work_order_date.value.value);
            values.project_deliverable_date = formattedDate(project_deliverable_date.value.value);
            values.retention_return_date = formattedDate(retention_return_date.value.value);
            values.status = '1';
            values.authors = proxy.authors;

            loading.value = true;
            store
                .dispatch("saveUpdateProject", values)
                .then((response) => {
                resetForm();
                loading.value = false;
                toast.success(response.data.message, {
                    timeout: 3000,
                });
                setTimeout(() => {
                    store.dispatch("getProjectList");
                    router.push({ name: "project-list" });
                }, 2000);
                })
                .catch((error) => {
                loading.value = false;
                    console.error("Error:", error);
                    toast.error(error.response?.data?.message || "An error occurred");
                });
        });

        return {
            formattedDate,
            submitForm,
            submit,
            project_title,
            contact_id,
            project_type_id,
            customer_name,
            customer_address,
            start_date,
            end_date,
            work_order_no,
            work_order_date,
            description,
            address,
            amount,
            retention,
            retention_per,
            expense_limit,
            installation_type,
            registration_type,
            project_deliverable_date,
            retention_return_date,
            whatsapp_link,
            google_link,
            approval_ref,
            project_date,
            authors,
            status,
            errorMessages,
            isEntryMode,
            project_id,
            resetForm,
            loading,
        };
    },

    mounted() {
        this.loadData()
        this.project_date.value.value = new Date();
    },
};
</script>
